<template>
  <div>
    <div v-if="loading">
      <spinner-component :height="data.height"></spinner-component>
    </div>
    <div v-if="chartData.error">
      <span><strong>This chart can't being drawn, because it doesn't exists anymore</strong></span>
    </div>
    <div :style="{visibility: loading ? 'hidden': 'visible'}">
      <div v-if="canExport" class="item-settings btn-group mr-1">
        <b-dropdown right variant="link" size="md" no-caret class="mr-1" v-b-tooltip.hover title="Export">
          <template slot="button-content">
            <font-awesome-icon icon="download" />
          </template>
          <b-dropdown-item v-if="isChart" @click="exportChart('png')">Export as PNG</b-dropdown-item>
          <b-dropdown-item @click="exportChart('csv')">Export as CSV</b-dropdown-item>
          <b-dropdown-item @click="exportChart('xls')">Export as XLS</b-dropdown-item>
        </b-dropdown>
      </div>
      <div class="results" v-if="chartData.chartType === 'table'">
        <ag-grid-wrapper
          ref="tableComponent"
          :items="chartData.data"
          :fields="chartData.fieldsTable"
          :fieldsDefinition="chartData.fieldsDefinition"
          :pivotMode="chartData.pivotMode"/>
      </div>
      <div v-else>
        <big-number v-if="chartData.chartType === 'bigNumber'" v-bind:chartData="chartData" ref="chartComponent" :show="show"></big-number>
        <div v-else>
          <div>
            <pre v-if="!isProd">
            {{ JSON.stringify(chartData) }}
            </pre>
            <chart-js v-if="visualization.chart_library === 'chartjs'" v-bind:chartData="chartData" :styles="myStyles" ref="chartComponent"></chart-js>
            <div v-if="chartData.chartType === 'pie'">
                Total: {{ parseFloat(chartData.data.reduce((acc, cur) => {
                    return parseFloat(acc) + parseFloat(cur[chartData.metric])
                }, 0)).toLocaleString() }}
            </div>
          </div>
          <div v-show="chartData.data.length === 0 && !loading" class="text-center">
            <span>No data to display</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SpinnerComponent from './Spinner-loader';
  import chartJs from '../graphs/chartJs';
  import bigNumber from "../graphs/bigNumber";
  import exportChart from '../mixins/exportChart';
  import {mapState, mapGetters} from 'vuex';
  import { createHelpers } from 'vuex-map-fields';
  import AgGridWrapper from './AgGridWrapper';

  const { mapFields } = createHelpers({
    getterType: 'visualizations/getField',
    mutationType: 'visualizations/updateField',
  });

  export default {
    name: "Chart",
    props: ['data', 'id', 'report_id', 'show', 'exportOption'],
    mixins: [exportChart],
    components: {
      chartJs,
      bigNumber,
      SpinnerComponent,
      AgGridWrapper
    },
    data() {
      return {
        chartData: {
          chartType: 'bar',
          selector: 'chart'+this.id,
          title: '',
          width: this.data.width,
          height: this.data.height,
          metric: -1,
          metricMixed: -1,
          metricStacked: -1,
          dim: -1,
          field: '',
          fieldsTable: '',
          fieldsDefinition: [],
          pivotMode: false,
          description: '',
          data: [],
          options: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: ''
            },
            scales: {
              xAxes: [{
                stacked: true,
                ticks: {
                  beginAtZero: true
                }
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          },
          error: false,
          stackedBar: false,
        },
        visualization: {
          chart_library: 'chartjs',
        },
        loading: true,
      };
    },
    methods: {
      graph() {
        this.loading = false;
        if (this.chartData.chartType !== 'table') {
          this.$refs.chartComponent.graph();
        }
      },
      create(refresh) {
        this.loading = true;
        this.$store.dispatch('visualizations/fetchVisualizationForReport', {
          visualization_id: this.data.idVisualization,
          report_id: this.report_id ? this.report_id : '',
        }).then((response) => {
          this.chartData.chartType = response.data.data.visualization.type;
          this.chartData.title = response.data.data.visualization.title;
          let objdata = JSON.parse(response.data.data.visualization.data);
          this.chartData.dim = objdata.xaxis;

          if (this.chartData.chartType === 'table') {
            this.chartData.fieldsTable = objdata.fields;
            this.chartData.fieldsDefinition = objdata.fieldsDefinition;
            this.chartData.pivotMode = objdata.pivotMode;
          }
          else if (this.chartData.chartType === 'mixed') {
            this.chartData.metricMixed = objdata.yaxis;
          }
          else if((this.chartData.chartType === 'bar' || this.chartData.chartType === 'vbar') && objdata.stacked) {
            this.chartData.metricStacked = objdata.yaxis;
            this.chartData.metric = objdata.yaxis[0].field;
            this.chartData.metricStacked.splice(0, 1);
            this.chartData.stackedBar = true;
          }
          else {
            this.chartData.metric = objdata.yaxis;
          }

          this.chartData.field = objdata.field;
          this.chartData.description = objdata.description;

          this.visualization.chart_library = response.data.data.visualization.chart_library;

          let params = {
            parameters: [],
            refresh,
          };
          let that = this;
          if (this.report_id) {
            if (this.parametersChart !== "") {
              this.parametersChart.forEach(function (el) {
                if (el.idVisualization.includes(that.data.idVisualization)) {
                  params.parameters.push(el);
                }
              });
            }
          }
          else {
            params.parameters = this.parametersChart;
          }

          axios.post('query/execute/' + response.data.data.visualization.query_id, params).then(response => {
            this.chartData.data = response.data.data.results;
            if (!this.report_id && this.parametersChart.length === 0) {
              this.$store.commit('reports/SET_REPORT_PARAMETERS', this.parametersVisualization);
            }
            this.$store.commit('visualizations/SET_CHARTDATA_DATA', response.data.data.results);
            this.graph();
          });
        })
          .catch(error => {
            this.chartData.error = true;
            this.loading = false;
            this.$store.dispatch('setExceptions', {message: 'Some charts cannot be drawn', data: []})
          });
      },
      reset() {
        this.$store.commit('queries/SET_PARAMETERS', []);
        this.$store.commit('visualizations/SET_VISUALIZATION_PARAMETERS', []);
        this.$store.commit('visualizations/SET_PARAMETERS');
        this.$store.commit('reports/SET_REPORT_PARAMETERS', []);
        this.$store.commit('reports/SET_PARAMETERS');
      },
    },
    computed: {
      ...mapState('reports', {
        parametersChart: 'parametersChart',
      }),
      ...mapState('visualizations', {
        parametersVisualization: 'parameters',
      }),
      ...mapFields([
        'chartData.fieldsTable',
      ]),
      ...mapGetters('reports', {
        getParametersChart: 'parametersChart',
      }),
      myStyles () {
        return {
          height: `${this.data.height}px`,
          position: 'relative'
        }
      },
      canExport() {
        return this.exportOption && !this.isBigNumber;
      },
      isBigNumber() {
        return this.chartData.chartType === 'bigNumber';
      },
      isChart() {
        return !this.isBigNumber && !this.isTable;
      },
      isTable() {
        return this.chartData.chartType === 'table';
      },
      isProd() {
        return window.config.isProd;
      }
    },
    created() {
      if(this.data.idVisualization) {
        this.create();
      }
    },
    watch: {
      'data.width'() {
        this.chartData.width = this.data.width;
        this.graph();
      },
      'data.height'() {
        this.chartData.height = this.data.height;
        this.graph();
      },
      'parametersChart'(val) {
        this.create(true);
      },
    }
  }
</script>
